<template>
  <v-container fluid ma-0 pa-0>
    <div class="fixed-header" :class="{ mobile: $vuetify.breakpoint.smAndDown }">
      <!-- if has summary fields add class 'with-summary' -->
      <v-layout align-center fill-height class="fixed-header-wrapper">
        <v-flex shrink class="text-truncate" pr-4>
          <v-tooltip color="secondary" bottom>
            <template v-slot:activator="{ on }">
              <h2 v-on="on" class="p-relative text-truncate">
                Chat
              </h2>
            </template>
            <span>Chat</span>
          </v-tooltip>
          <h4 class="pt-1 sub-header ">Ask me about your cases</h4>
        </v-flex>
        <v-spacer></v-spacer>
      </v-layout>
    </div>

    <div id="chat">
      <div class="chat-container">
        <div class="menu-container">
          <ChatMenu></ChatMenu>
        </div>
        <div class="session-container">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import ChatMenu from "./ChatMenu.vue"
import { mapState } from "vuex"

export default {
  name: "ChatContainer",
  components: {
    ChatMenu
  },
  computed: {
    ...mapState({
      chatSession: state => state.chat.currentSession
    })
  }
}
</script>
<style lang="scss" scoped>
#chat {
  height: calc(100vh - 110px) !important;
  padding: 0;
  margin: 0;
  background-color: white;

  .chat-container {
    display: flex;
    height: 100%;
    margin: 0;
    padding: 0;

    .menu-container {
      flex: 0;
      width: 280px;
    }

    .session-container {
      flex: 1;
      width: 100%;
      overflow: scroll
    }
  }
}
</style>